import { Box, Grid, styled, Typography } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { api } from '../../../api';
import { CCTVFilter, getCCTVSearchParams } from './filter';

interface SummaryCCTV {
  total: number;
  total_pass: number;
  total_not_pass: number;
  total_unknown: number;
}
type SummaryNumberInOutProps = CCTVFilter;

const SummaryNumberInOut: React.FC<SummaryNumberInOutProps> = ({
  filterID,
  filterName,
  filterGateIDList,
  filterCompanyIDList,
  filterPersonTypeIDList,
  filterStartDate,
  filterEndDate
}: SummaryNumberInOutProps) => {
  const [summary, setSummary] = useState<SummaryCCTV>({
    total: 0,
    total_pass: 0,
    total_not_pass: 0,
    total_unknown: 0
  });

  const summaryData = useMemo(
    () => [
      { title: 'แสกนทั้งหมด', amount: summary.total },
      { title: 'แสกนผ่าน', amount: summary.total_pass },
      { title: 'แสกนไม่ผ่าน', amount: summary.total_not_pass },
      // { title: 'ไม่พบข้อมูลบุคคล (Unknown)', amount: summary.total_unknown }
    ],
    [summary]
  );

  useEffect(() => {
    const searchParams = getCCTVSearchParams({
      filterID,
      filterName,
      filterGateIDList,
      filterCompanyIDList,
      filterPersonTypeIDList,
      filterStartDate,
      filterEndDate
    });
    api.get<SummaryCCTV>(`/scan-cctv/summary`, { params: searchParams }).then((res) => {
      setSummary(res.data);
    });
  }, [
    filterID,
    filterName,
    filterGateIDList,
    filterCompanyIDList,
    filterPersonTypeIDList,
    filterStartDate,
    filterEndDate
  ]);

  return (
    <Box>
      <Grid container>
        {summaryData.map((item, index) => (
          <SummaryAmountGrid item xs={3} key={`summary-box-${index}`}>
            <SummaryAmountBox>
              <Typography variant="caption">{item.title}</Typography>
              <Typography variant="h6">{item.amount}</Typography>
            </SummaryAmountBox>
          </SummaryAmountGrid>
        ))}
      </Grid>
    </Box>
  );
};

export default SummaryNumberInOut;

const SummaryAmountBox = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  padding: 16
}));

const SummaryAmountGrid = styled(Grid)({
  borderRight: '1px solid lightgray',
  '&:last-child': {
    borderRight: 'none'
  }
});
